import { Box, Flex, Typo, xlBumps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../../organisms/trans'
import { FullPage } from '../../../../templates'

const tKey = TKey('pages.invalid-adjustment')

export const InvalidPolicyAdjustmentPage: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <FullPage pageId='invalid-state-adjustment-page' header={t(tKey('header'))}>
      <Box mb={xlBumps}>
        <Typo as='pre'>
          <WriskTrans t={t} i18nKey={tKey('subheader')} />
        </Typo>
      </Box>
      <Flex width={1}>
        <WriskTrans t={t} i18nKey={tKey('contact-us')} />
      </Flex>
    </FullPage>
  )
}
